import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeedService } from 'src/app/core/services/feed/feed.service';
import { Region } from 'src/app/shared/models/dtos/region/region';

export interface RegionFilterModalData {
  regions?: Region[];
}

@Component({
  selector: 'app-region-filter-modal',
  templateUrl: './region-filter-modal.component.html',
})
/**
 * Region filter modal
 */
export class RegionFilterModalComponent implements OnInit {
  @Output() submitClicked = new EventEmitter<any>();
  form = new FormGroup({});
  /**
   * @constructor
   */
  constructor(
    public dialogRef: MatDialogRef<RegionFilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegionFilterModalData,
    private readonly feedService: FeedService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    for (const region of this.availableRegions || []) {
      this.form.addControl(
        region.id.toString(),
        new FormControl<boolean>(true)
      );
    }
  }

  /**
   * Available regions
   */
  get availableRegions() {
    return this.feedService.availableRegions;
  }

  /**
   * Action to close the dialog
   */
  onCloseClick() {
    this.dialogRef.close();
  }

  readonly cancel = this.onCloseClick;

  /**
   * Submits selected regions
   * not yet implemented
   */
  submit() {
    const obj = this.availableRegions;
    this.dialogRef.close(obj);
    this.submitClicked.emit(obj);
  }

  /**
   * Maps id to region name
   * @param {string} id
   * @return {any} needs refinement
   */
  getRegionName(id: string): any {
    if (!this.availableRegions) return;
    for (const region of this.availableRegions) {
      if (region.id.toString() === id) {
        return region.name;
      }
    }
  }
}
